import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ClienteContatoService } from "@core/services/cliente-contato.service";
import { ClienteService } from "@core/services/cliente.service";
import { LeadContatoService } from "@core/services/lead-contato.service";
import { LeadService } from "@core/services/lead.service";
import { SistemaService } from "@core/services/sistema.service";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { AuthenticationService } from "app/auth/service";
import { FileUploader } from "ng2-file-upload";
import { GlobalConfig, ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";

@Component({
	selector: 'app-form-lead',
	templateUrl: './form-lead.component.html',
	styleUrls: ['./form-lead.component.scss']
})
export class FormLeadComponent implements OnInit {
	//ngModel cliente
	public id_lead;
	public nomeFantasia;
	public emailDadosCliente;
	public razaoSocial;
	public nomeContratante;
	public documento;
	public documentoVerificacao;
	public endereco;
	public numero;
	public complemento;
	public bairro;
	public cidade;
	public estadoModel;
	public cep;
	public observacao;
	public usuarioCadastrado = false;

	//ngModel faturamento
	public enderecoFaturamento;
	public numeroFaturamento;
	public complementoFaturamento;
	public bairroFaturamento;
	public cidadeFaturamento;
	public estadoModelFaturamento;
	public cepFaturamento;
	public observacaoFaturamento;
	public documentoFaturamento;
	public razaoSocialFaturamento;
	public simplesNacionalModel;
	public checkboxEnderecoValue = false;
	public checkboxEnderecoHidden = false;

	//ngModel Config Email
	public hostname;
	public porta;
	public autenticacao;
	public emailConfig;
	public usuarioEmail;
	public senhaEmail;

	//ngxDataTable
	public ColumnMode = ColumnMode;
	public basicSelectedOption: number = 10;
	public sistemas = [];
	public rows_contatos = [];
	public temp_contatos = [];
	public contato_error = false;

	//desabilitar abas no cadastro
	public dadosHidden = false;
	public faturamentoHidden = false;
	public contatoHidden = false;
	public exportHidden = false;
	public personalizacaoHidden = false;
	public emailHidden = false;

	//Model exportar rastreei
	public usuarioRastreei;
	public emailRastreei;
	public nomeRastreei;
	public smsRastreei;
	public wppRastreei;

	//variaveis gerais
	public pageLoading = true;
	public array_dados_geral = {};
	public componentId;
	public usuarioFaleFlex;
	public password;
	public confirm_password;
	public href;
	public contentHeader: object;
	private routeSub: Subscription;
	public isLoading = false;
	public tabActive;
	public res = [];
	public contatosDefault = [];
	public sistemaId: number;
	public cidadeAPI: any;
	public hiddenCidadeExport = true;
	public cidadeExport;
	public tp_cadastro;
	flg_cliente;
	id_cliente;
	contatos = [];

	private options: GlobalConfig;
	public user = [];
	isUsuariorastreei = false;
	id: number;

	constructor(
		private route: ActivatedRoute,
		private leadService: LeadService,
		private clienteService: ClienteService,
		private sistemaService: SistemaService,
		private clienteContatoService: ClienteContatoService,
		private toastr: ToastrService,
		private _authenticationService: AuthenticationService,
		private leadContatoService: LeadContatoService,
		private _router: Router
	) {
		this.options = this.toastr.toastrConfig;
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit() {
		this.tabActive = 1;
		this.componentId = this.route.snapshot.params.id;

		if (this.componentId) {
			//obtem os todos os sistemas cadastrados
			this.sistemaService.getAtivos().subscribe(
				(res) => {
					this.sistemas = res;
				},
				(error) => error
			);

			// obtendo dados de contato do cliente selecionado
			this.leadContatoService.getContatos(this.componentId).subscribe(
				(res) => {
					if (res.length > 0) {
						res.forEach(element => {
							this.contatos.push({
								setor: element.setor,
								nome: element.nome,
								telefone: element.telefone,
								whatsapp: element.whatsapp,
								cpf_contratante: element.cpf_contratante,
								email: element.email,
								id_lead: null,
								isDefault: element.isDefault
							})
						});
					}
					this.rows_contatos = res;

				},
				(error) => error
			);

			//obtendo dados do cliente selecionado
			this.leadService.findOne(this.componentId).subscribe(
				(res) => {
					this.razaoSocial = res[0].razao_social;
					this.nomeFantasia = res[0].nome_fantasia;
					this.nomeContratante = res[0].nome_contratante;
					this.documento = res[0].cpf_cnpj_lead;
					this.documentoVerificacao = res[0].cpf_cnpj_lead;
					this.endereco = res[0].rua;
					this.numero = res[0].numero;
					this.complemento = res[0].complemento;
					this.bairro = res[0].bairro;
					this.cidade = res[0].cidade;
					this.estadoModel = res[0].estado;
					this.cep = res[0].cep;
					this.observacao = res[0].observacao;
					this.enderecoFaturamento = res[0].rua_faturamento;
					this.numeroFaturamento = res[0].numero_faturamento;
					this.complementoFaturamento = res[0].complemento_faturamento;
					this.bairroFaturamento = res[0].bairro_faturamento;
					this.cidadeFaturamento = res[0].cidade_faturamento;
					this.estadoModelFaturamento = res[0].estado_faturamento;
					this.cepFaturamento = res[0].cep_faturamento;
					this.documentoFaturamento = res[0].cpf_cnpj_lead_faturamento;
					this.razaoSocialFaturamento = res[0].razao_social_faturamento;
					this.simplesNacionalModel = res[0].simples_nacional;
					this.observacaoFaturamento = res[0].observacao_faturamento;
					this.usuarioRastreei = res[0].cpf_cnpj_lead;
					this.nomeRastreei = res[0].nome_contratante;
					this.id_lead = this.componentId;
					this.pageLoading = false;
					this.password = res[0].cpf_cnpj_lead.substring(0, 6);
					this.confirm_password = res[0].cpf_cnpj_lead.substring(0, 6);
					this.emailDadosCliente = res[0].email_lead;
					this.tp_cadastro = res[0].tp_cadastro;
					this.flg_cliente = res[0].flg_cliente;
					let estado = res[0].estado;

					if (this.flg_cliente == 1) {
						this.clienteService.getCpf(this.documento).subscribe(
							(res) => {
								if (res.length > 0) {
									this.id_cliente = res[0].id_cliente
								}
							}
						)
					}
					/**
					 * conferindo se a cidade do cliente existe na base de dados da fale flex
					 * (caso o cliente seja exportado para a fale flex, a cidade deve existir na base de dados da fale flex).
					 **/
					this.clienteService.getCity(res.cidade).subscribe(
						(res) => {
							if (res.qtd_resultados_retornados == 0) {
								this.clienteService.getCityByInitial(estado).subscribe(
									(res) => {
										this.cidadeAPI = res.dados;
										this.hiddenCidadeExport = false;
									},
									(error) => error
								);
							} else {
								this.cidadeExport = res.dados[0].id;
							}
						},
						(error) => error
					);

					// this.clienteService
					// 	.consultaIntegracaoUsuario(this.componentId)
					// 	.subscribe(
					// 		(res) => {
					// 			if (res.length > 0) {
					// 				this.isUsuariorastreei = true;
					// 			}
					// 		},
					// 		(error) => error
					// 	);
				},
				(error) => error
			);

			this.contentHeader = {
				headerTitle: "Editar Cliente",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Cliente",
							isLink: false,
						},
						{
							name: "Editar",
							isLink: false,
						},
					],
				},
			};

		} else {
			this.pageLoading = false;
			this.dadosHidden = true;
			this.faturamentoHidden = true;
			this.contatoHidden = true;
			this.exportHidden = true;
			this.personalizacaoHidden = true;
			this.emailHidden = true;
			this.checkboxEnderecoHidden = true;
			this.contentHeader = {
				headerTitle: "Cadastrar Lead",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Lead",
							isLink: false,
						},
						{
							name: "Cadastro",
							isLink: false,
						},
					],
				},
			};
		}
	}

	//Função: copia os dados do cliente para os campos de faturamento
	public checkboxEndereco(e) {
		this.checkboxEnderecoValue = !this.checkboxEnderecoValue;
		if (this.checkboxEnderecoValue) {
			this.enderecoFaturamento = this.endereco;
			this.numeroFaturamento = this.numero;
			this.complementoFaturamento = this.complemento;
			this.bairroFaturamento = this.bairro;
			this.cidadeFaturamento = this.cidade;
			this.estadoModelFaturamento = this.estadoModel;
			this.cepFaturamento = this.cep;
			this.observacaoFaturamento = this.observacao;
			this.documentoFaturamento = this.documento;
			this.razaoSocialFaturamento = this.razaoSocial;
		} else {
			this.enderecoFaturamento = "";
			this.numeroFaturamento = "";
			this.complementoFaturamento = "";
			this.bairroFaturamento = "";
			this.cidadeFaturamento = "";
			this.estadoModelFaturamento = "";
			this.cepFaturamento = "";
			this.observacaoFaturamento = "";
			this.documentoFaturamento = "";
			this.razaoSocialFaturamento = "";
		}
	}

	//Função: verifica se não há nenhum dado pendente de ser salvo antes de ir para tela de cadastro de contato
	public cadastrarContato(componentId, cadastroForm) {
		if (cadastroForm.dirty || this.checkboxEnderecoValue == true) {
			Swal.fire({
				title: "Dados não salvos",
				text: "Deseja prosseguir sem salvar?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sim",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-danger",
					cancelButton: "btn btn-primary ml-1",
				},
			}).then((result) => {
				if (result.isConfirmed) {
					this._router.navigate(['lead/contato/cadastro/' + this.componentId])
				}
			});
		} else {
			this._router.navigate(['lead/contato/cadastro/' + this.componentId])
		}
	}

	// Cadastrar/atualiza dados do cliente
	public submitForm(data: NgForm) {
		if (this.componentId) {
			this.array_dados_geral = {
				rua_faturamento: this.enderecoFaturamento == null ? null : this.enderecoFaturamento.toUpperCase(),
				numero_faturamento: this.numeroFaturamento == null ? null : this.numeroFaturamento.toUpperCase(),
				complemento_faturamento: this.complementoFaturamento == null ? null : this.complementoFaturamento.toUpperCase(),
				bairro_faturamento: this.bairroFaturamento == null ? null : this.bairroFaturamento.toUpperCase(),
				cidade_faturamento: this.cidadeFaturamento == null ? null : this.cidadeFaturamento.toUpperCase(),
				estado_faturamento: this.estadoModelFaturamento == null ? null : this.estadoModelFaturamento.toUpperCase(),
				cep_faturamento: this.cepFaturamento == null ? null : this.cepFaturamento.toUpperCase(),
				observacao_faturamento: this.observacaoFaturamento == null ? null : this.observacaoFaturamento.toUpperCase(),

				nome_contratante: this.nomeContratante == null ? null : this.nomeContratante.toUpperCase(),
				email_lead: this.emailDadosCliente == null ? null : this.emailDadosCliente.toUpperCase(),
				nome_fantasia: this.nomeFantasia == null ? null : this.nomeFantasia.toUpperCase(),
				razao_social: this.razaoSocial == null ? null : this.razaoSocial.toUpperCase(),
				cpf_cnpj_lead: this.documento == null ? null : (this.documento.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				numero: this.numero == null ? null : this.numero.toUpperCase(),
				complemento: this.complemento == null ? null : this.complemento.toUpperCase(),
				rua: this.endereco == null ? null : this.endereco.toUpperCase(),
				bairro: this.bairro == null ? null : this.bairro.toUpperCase(),
				cidade: this.cidade == null ? null : this.cidade.toUpperCase(),
				estado: this.estadoModel.toUpperCase(),
				cep: this.cep == null ? null : (this.cep.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				observacao: this.observacao == null ? null : this.observacao.toUpperCase(),
				tp_cadastro: 'INTERNO',

				simples_nacional: this.simplesNacionalModel,
				cpf_cnpj_lead_faturamento: this.documentoFaturamento == null ? null : (this.documentoFaturamento.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				razao_social_faturamento: this.razaoSocialFaturamento == null ? null : this.razaoSocialFaturamento.toUpperCase(),
			};

			//verificando se o novo cpf ja esxiste
			if (this.documento != this.documentoVerificacao) {
				this.leadService.getCpf(this.documento).subscribe((result) => {
					if (result.length == 0) {
						this.isLoading = true;
						this.updateLead()
					} else {
						this.isLoading = false;
						Swal.fire("Atenção!", "Este CPF/CNPJ já existe!", "error");
					}
				});
			} else {
				this.isLoading = true;
				this.updateLead()
			}

		} else {
			if (
				this.bairro != undefined &&
				this.razaoSocial != undefined &&
				this.observacao != undefined &&
				this.numero != undefined &&
				this.nomeFantasia != undefined &&
				this.nomeContratante != undefined &&
				this.estadoModel != undefined &&
				this.endereco != undefined &&
				this.documento != undefined &&
				this.complemento != undefined &&
				this.cidade != undefined &&
				this.cep != undefined
			) {
				this.array_dados_geral = {
					nome_contratante: this.nomeContratante,
					nome_fantasia: this.nomeFantasia,
					razao_social: this.razaoSocial,
					email_lead: this.emailDadosCliente,
					cpf_cnpj_lead: this.documento,
					numero: this.numero,
					complemento: this.complemento,
					rua: this.endereco,
					bairro: this.bairro,
					cidade: this.cidade,
					estado: this.estadoModel,
					cep: this.cep,
					observacao: this.observacao,
					tp_cadastro: 'INTERNO'
				};

				this.leadService.getCpf(this.documento).subscribe((result) => {
					if (result.length == 0) {
						this.isLoading = true;
						this.leadService.create(this.array_dados_geral).subscribe(
							(res) => {
								if (res) {
									this.isLoading = false;
									Swal.fire({
										title: "Sucesso!",
										text: "Complete os dados adicionais do cliente.",
										icon: "success",
										confirmButtonText: "Confirmar",
									}).then((result) => {
										if (result.isConfirmed) {
											// location.href = "/cliente/editar/" + res.insertId;
											this._router.navigate(["/lead/editar/" + res.id_lead])
										}
									});
								}
							},
							(error) => {
								this.isLoading = false;
								Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
							}
						);
					} else {
						this.isLoading = false;
						Swal.fire("Atenção!", "Este CPF/CNPJ já existe!", "error");
					}
				});
			} else {
				this.isLoading = false;
				Swal.fire(
					"Campos obrigatórios!",
					"Preencha todos os campos para prosseguir",
					"error"
				);
			}
		}
	}

	updateLead() {
		this.leadService
			.update(this.array_dados_geral, this.componentId)
			.subscribe(
				(res) => {
					this.isLoading = false;
					Swal.fire({
						title: "Sucesso!",
						text: "O item atualizado com sucesso.",
						icon: "success",
						confirmButtonText: "Confirmar",
					}).then((result) => {
						this._router.navigate(["/lead/editar/" + this.componentId])
					});
				},
				(error) => {
					Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
				}
			);
	}

	tornarCliente() {

		Swal.fire({
			title: "Deseja tornar esse lead um cliente?",
			text: "O lead se tornará um cliente do Grupo 2E.",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				this.array_dados_geral = {
					rua_faturamento: this.enderecoFaturamento == null ? null : this.enderecoFaturamento.toUpperCase(),
					numero_faturamento: this.numeroFaturamento == null ? null : this.numeroFaturamento.toUpperCase(),
					complemento_faturamento: this.complementoFaturamento == null ? null : this.complementoFaturamento.toUpperCase(),
					bairro_faturamento: this.bairroFaturamento == null ? null : this.bairroFaturamento.toUpperCase(),
					cidade_faturamento: this.cidadeFaturamento == null ? null : this.cidadeFaturamento.toUpperCase(),
					estado_faturamento: this.estadoModelFaturamento == null ? null : this.estadoModelFaturamento.toUpperCase(),
					cep_faturamento: this.cepFaturamento == null ? null : this.cepFaturamento.toUpperCase(),
					observacao_faturamento: this.observacaoFaturamento == null ? null : this.observacaoFaturamento.toUpperCase(),

					nome_contratante: this.nomeContratante == null ? null : this.nomeContratante.toUpperCase(),
					email_cliente: this.emailDadosCliente == null ? null : this.emailDadosCliente.toUpperCase(),
					nome_fantasia: this.nomeFantasia == null ? null : this.nomeFantasia.toUpperCase(),
					razao_social: this.razaoSocial == null ? null : this.razaoSocial.toUpperCase(),
					cpf_cnpj_cliente: this.documento == null ? null : (this.documento.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
					numero: this.numero == null ? null : this.numero.toUpperCase(),
					complemento: this.complemento == null ? null : this.complemento.toUpperCase(),
					rua: this.endereco == null ? null : this.endereco.toUpperCase(),
					bairro: this.bairro == null ? null : this.bairro.toUpperCase(),
					cidade: this.cidade == null ? null : this.cidade.toUpperCase(),
					estado: this.estadoModel.toUpperCase(),
					cep: this.cep == null ? null : (this.cep.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
					observacao: this.observacao == null ? null : this.observacao.toUpperCase(),
					tp_cadastro: this.tp_cadastro,

					simples_nacional: this.simplesNacionalModel,
					cpf_cnpj_cliente_faturamento: this.documentoFaturamento == null ? null : (this.documentoFaturamento.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
					razao_social_faturamento: this.razaoSocialFaturamento == null ? null : this.razaoSocialFaturamento.toUpperCase(),
				};

				this.clienteService.getCpf(this.documento).subscribe((result) => {
					if (result.length == 0) {
						this.isLoading = true;
						this.clienteService.post(this.array_dados_geral).subscribe(
							(res) => {
								if (res) {
									this.contatos.forEach(element => {
										// console.log(element);
										// if (element.setor == 'CONTRATANTE') {
										// 	element['cpf_contratante']  = this.cpf_contratante;
										// }
										element.id_cliente = res.id_cliente
										this.clienteContatoService.create(element).subscribe();
									});
									this.isLoading = false;
									this.leadService.tornarCliente(this.componentId).subscribe(
										(resTornarCliente) => {
											Swal.fire({
												title: "Sucesso!",
												text: "Você será redirecionado(a) para tela do cliente.",
												icon: "success",
												confirmButtonText: "Confirmar",
											}).then((result) => {
												if (result.isConfirmed) {
													this._router.navigate(["/cliente/editar/" + res.id_cliente])
												}
											});
										},
										(err) => {
											console.log(err);
											Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
										}
									);
								}
							},
							(error) => {
								this.isLoading = false;
								Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
							}
						);
					} else {
						this.isLoading = false;
						Swal.fire("Atenção!", "Não foi possível cadastrar! Este CPF/CNPJ já pertence a um cliente.", "error");
					}
				});
			}
		});
	}
}
